const currentHost = process.env.REACT_APP_BASE_HOST;
const currentAPI = process.env.REACT_APP_API_BASE_URL;
const walletAPI = process.env.REACT_APP_WALLET_API_BASE_URL;
const trivialGameAPI = process.env.REACT_APP_TRIVIAL_GAME_API;
const billsAPI = process.env.REACT_APP_VAS_BILLS_API;
const BILL_AUTH_KEY = process.env.REACT_APP_VAS_BILLS_AUTH_KEY;

export { currentAPI, currentHost, walletAPI, trivialGameAPI, billsAPI, BILL_AUTH_KEY };
